import { str } from './str.js'
import { int } from './int.js'
import { DOM } from './dom.js'
import { PlayList } from './playlist.js'
export class Player {
    constructor(options){
        window.player = this
        this.company_id = DOM.select('[data-company]').dataset.company
        this.options = options

        this.jQuery({ onLoad(){
            console.log(options)
            player.player = player.setPlayer()
            if(Array.isArray(options.init))
                options.init.forEach( option => player[option]())

            if(options.playlist){
                this.playlist = new PlayList(this,options.playlist)
            }
        }})
        this.playList = playlist => new PlayList(this,playlist)

    }
    /**
     *
     * @param {*} options
     */
    options(options) {
        if(typeof options === 'object'){

            Object.keys(options).forEach( option => {
                //onsole.log(options[option])
                if(typeof player[option] === 'function')
                    player[option](options[option])
            })
        }
    }
    stop() {
        if(!this.playlist) return
        this.playlist.stop()
    }
    /**
     *
     * @param {*} options
     */
    logo(options) {
        document.body.appendChild(DOM.element('img',{
            src : options?.src ? options.src :  'images/logo_displaybooster.svg',
            style : 'width:200px;',
            id : options?.id ? options.id : 'logo'

        }))
    }
    /**
     *
     * @returns {HTMLElement}
     */
    setPlayer(){
        const current = DOM.element('player',false),
              player = current ? DOM.element('player') : DOM.element('div',{ id : 'player', style : 'display: flex; justify-content: center;'})
        if(!current)
            document.body.appendChild(player)
            document.body.addEventListener('contextmenu',event => {
                return false
            })
        return player
    }
    /**
     * Creates <video> element
     * @param {*} options
     */
    createVideo(options) {
        const id = options.id ? options.id : str.getRandom(32),
              content_name_arr = options.content_name.split('.'),
              target = options.target ? options.target : 'player',
              video = DOM.element('video', {
                id : id,
                //src : 'res/' + options.content_name,
                src : `/uploads/${player.company_id}/${options.content_id}.${content_name_arr.at(-1)}`,
                // Sets 'canplaythrough' event listener
                canplaytrough(event){
                    //event.target.play()
                    //event.target.autoplay = true
                }
            })
            //video.appendChild(source)
            video.style.width = '100vw'
            video.autoplay = true
            video.play()
        //console.log(video)
        DOM.element(target).appendChild(video)
        return video
    }

    createIframe(options){
        const id = options.id ? options.id : str.getRandom(32),
              target = options.target ? options.target : 'player',
              iframe = DOM.element('iframe', {
                id : id,
                frameborder : 0,
                width : options.width ? options.width : '100%',
                height : options.height ? options.height : '100%',
                style : 'border:0px;',
                frameborder:0,
                src : 'res/'+options.content_name
            })
        if(options.asVideo){

            iframe.src = 'player.html'
            iframe.addEventListener('load',event => {
                const contentDocument = iframe.contentDocument
                //console.log(iframe,contentDocument)
                contentDocument.body.appendChild(player.createVideo(options))
            })

        }
        DOM.element(target).appendChild(iframe)
        return iframe

    }
    jQuery(options){
        const script = script => DOM.element('script',{src : script}),
             jquery = script(`https://code.jquery.com/jquery-${options.version ? options.version : '2.1.3' }${ options.slim ? '-slim' : '' }.js`),
             jquery_ui = script(`https://code.jquery.com/ui/${options.ui ? options.ui : '1.13.2' }/jquery-ui.js`)
        DOM.select('head').appendChild(jquery)


            jquery.addEventListener('load',()=>{
                DOM.select('head').appendChild(jquery_ui)
                if(typeof options.onLoad === 'function')
                    options.onLoad()
            })

    }
    /**
     *
     * @param {*} options
     * @returns
     */
    createImage(options){
        console.log(options)
        const content_name_arr = options.name.split('.'),
              image = DOM.element('img',{
            //src : 'res/' + options.content_name
            src : `/uploads/${player.company_id}/${options.content_id}.${options.extension}`
        })
        image.style.width = '100vw'
        return image
    }
    /**
     *
     */
    clear(){
        this.player.textContent = ''
    }
    /**
     *
     * @param {*} options
     */
    backgroundVideo(options){
        const media_url = media => `https://upload.wikimedia.org/wikipedia/commons/${media}_Free_Vj_Loop.webm`,
        backgrounds = {
            smooth_wave : media_url('b/b7/Smooth_wave'),
            retro_lines : media_url('7/71/70%C2%B4s_Retro_Lines'),
            color_collage : media_url('c/c3/Collage_of_Colors_--'),
            fake_crystals : media_url('e/e8/Fake_Crystals'),
            fluid_pulse : media_url('f/f8/Fluid_Pulse'),
            subtle_distortion : media_url('c/ce/Subtle_Distortion'),
            growing_squares : media_url('0/01/Growing_Square'),
            lines : media_url('0/06/Lines'),
            cubes : media_url('7/77/Cubes'),
            atmosphere : media_url('6/6a/Atmosphere').replace('Loop','loop'),
            electric_paralels : media_url('7/74/Electric_Parallels'),
            smooth_movement : media_url('b/b7/Looped_Smooth_movement'),
            ranura : media_url('4/4b/Ranura'),
            tesseract : media_url('7/7a/Tesseract'),
            color_machine : media_url('e/e5/Color_Machine.'),
            square_roots : media_url('5/5a/Square_roots')
        },video = options => {
            const video = document.createElement('video')
            Object.keys(options).forEach(option => video[option] = options[option])
            if(options.class) video.classList.add(options.class)
            return video
        },randomBackground = () => {
            const index = Math.floor(Math.random()*Object.keys(backgrounds).length),
            background = backgrounds[Object.keys(backgrounds)[index]]
            return background
        },
        background = video({
            loop : true,
            muted : true,
            autoplay : true,
            class : 'bg',
            src : options?.background ? backgrounds[options.background] : randomBackground(),
            //playbackRate : 0.4
        })
        document.body.appendChild(background)
        background.play()
        if(!options?.background){
            setInterval(() => {
                background.src = randomBackground()
            }, 15000);
        }
        return {
            remove(){
                background.remove()
            },
            change(_background){
                background.src = backgrounds[_background]
            },
            speed(rate){
                background.playbackRate = rate
            }
        }
    }
    backgroundAnimation(){
        document.body.classList.add('gradient_animation')
    }
    /**
     *
     * @param {*} video
     */
    ambientMode(video){
        const canvas = ui.element('canvas',{ class : 'ambient'}),
              ctx = canvas.getContext('2d')
        document.body.appendChild(canvas)
        video.addEventListener('play', function() {
            const $this = this //cache
            (function loop() {
                if (!$this.paused && !$this.ended) {
                    ctx.drawImage($this, 0, 0)
                    setTimeout(loop, 1000 / 30) // drawing at 30fps
                }
            })()
        }, 0)
        return {
            remove(){
                DOM.select('canvas.ambient').remove()
            }
        }
    }
    /**
     * Sets the clock
     * @param {*} options
     * @returns
     */
    clock(options = {
        color : 'white',
        format : 'h:m:s',
        position : {
            top : '15px',
            right : '15px'
        }
    }){
        const current = DOM.element('clock',false),
              clock = current ? DOM.element('clock') : DOM.element('div',{ id : 'clock', style : `color:${options.color};top:${options.position.top}px;right:${options.position.right}px;`})
        let refresh
        if(!current)
            document.body.appendChild(clock)
        function startTime() {
            if(refresh) clearTimeout(refresh)
            if(!clock) return
            const today = new Date(),
                  h = today.getHours(),
                  m = checkTime(today.getMinutes()),
                  s = checkTime(today.getSeconds())
            // let time = options.format
            // time = time.replace('h',h)
            // time = time.replace('m',m)
            // time = time.replace('s',s)
            clock.textContent = `${h}:${m}`
            refresh = setTimeout(startTime, 1000)
          }
          function checkTime(i) {
            if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
            return i;
          }
          startTime()
          $(clock).fadeIn()
          return {
            remove(){
                clock.remove()
            }
          }
    }
    async timeWeatherData(lat = 51,lon = 3){
        const weather_data_request = await fetch(`https://gps.buienradar.nl/getrr.php?lat=${lat}&lon=${lon}`, { mode: 'no-cors'}),
              weather_data = await weather_data_request.text()
        //console.log(weather_data)

    }
    /**
     *
     * @param {*} options
     * @returns
     */
    async ticker(options = {
        feed : 'nu.nl'

    }){
        const ticker = DOM.element('div',{class : 'ticker'}),
              wrap = DOM.element('div',{class : 'ticker-wrap', style : 'display:none;'},ticker),
              feeds_data = await fetch('data/rss_feeds.json'),
              feeds = await feeds_data.json()
              document.body.appendChild(wrap)
            //   feeds = {
            //     'nos' : {
            //         url : 'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Ffeeds.nos.nl%2Fnosnieuwsalgemeen',
            //     },
            //     'nu.nl' : {
            //         url : 'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.nu.nl%2Frss%2FAlgemeen',
            //     },
            //     'volkskrant' : {
            //         url : 'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.volkskrant.nl%2Fvoorpagina%2Frss.xml'
            //     },
            //     'ad' : {
            //         url : 'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.ad.nl%2Fhome%2Frss.xml'
            //     },
            //     'nrc' : {
            //         url: 'https://api.rss2json.com/v1/api.json?rss_url=http%3A%2F%2Ffeeds.feedburner.com%2Fnrc%2FFmXV'
            //     },
            //     'telegraaf' : {
            //         url : 'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.telegraaf.nl%2Frss'
            //     },
            //     'verkeersplaza' : {
            //         url : 'https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fwww.verkeerplaza.nl%2Frssfeed'
            //     }

            //  }
        ticker.textContent = ''
        $.get(feeds[options.feed].url, data => {
            $(wrap).fadeIn()
            //ticker.appendChild(DOM.element('div',{class : 'ticker__item'},feeds[options.feed].logo))
            //console.log(data.items)
            data.items.forEach(item =>{
                ticker.appendChild(DOM.element('div',{class : 'ticker__item'},'<span>'+item.title+'</span>'))
            })
        })
        //https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Ffeeds.nos.nl%2Fnosnieuwsalgemeen
        return{
            remove(){
                ticker.remove()
            },
            add(item){
                ticker.appendChild(DOM.element('div',{class : 'ticker__item'},'<span>'+item+'</span>'))
            }
        }
    }
    debug(){
        this.refreshRate()
    }

    refreshRate(){
        const element = DOM.element('div',{ style : 'position: absolute;top:10px;left:10px; color:white;font-size:0.5em;opacity:0.75;'}), times = []
        let fps
        document.body.appendChild(element)

        function refreshLoop() {
            window.requestAnimationFrame(() => {
                const now = performance.now();
                while (times.length > 0 && times[0] <= now - 1000) {
                    times.shift()
                }
                times.push(now)
                fps = times.length
                refreshLoop()
                setTimeout(()=>{
                    const _now = performance.now(),
                          memory = window.performance.memory.totalJSHeapSize - window.performance.memory.usedJSHeapSize
                    element.textContent = fps +' fps / '+ Math.floor( _now - now) + ' ms / ' + (memory) + ' bytes ('+int.formatBytes(memory)+')'
                },0)

            })
        }

        refreshLoop()
    }

}
